<template>
  <div class="list__header flex px-6 space-x-6">
    <div v-if="selectable" class="flex-none py-3">
      <label class="custom-checkbox">
        <input type="checkbox" @input="handleCheckbox" />
        <span />
      </label>
    </div>
    <div class="flex-1 py-3">
      <slot />
    </div>
    <div v-if="actionable" class="flex-none py-3 -mr-3">
      <span class="block w-16" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectable: Boolean,
    actionable: Boolean,
  },
  methods: {
    handleCheckbox(ev) {
      const { checked } = ev.target;
      this.$emit('checked', checked);
    },
  },
};
</script>
